import React, {useEffect} from 'react';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import AccountCircleSharpIcon from '@material-ui/icons/AccountCircleSharp';
import SwapVerticalCircleSharpIcon from '@material-ui/icons/SwapVerticalCircleSharp';
import SupervisedUserCircleSharpIcon from '@material-ui/icons/SupervisedUserCircleSharp';
import {Grid} from "@material-ui/core";
import {RegisterStepComponents, RegisterStepTwo, RegisterStepThree} from "./RegisterStepComponents";
import { useGlobalStore } from "../store/GlobalContext";
import {RenderLogoFade} from "../content_page/util"

export default function HorizontalLabelPositionBelowStepper() {
    const [activeStep, setActiveStep] = React.useState(0);
    const [{ logo_register }, dispatch] = useGlobalStore();

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const steps = [
            {label:'สมัครออโต้',icon:<AccountCircleSharpIcon fontSize={'large'} color={ (activeStep === 0) ? 'primary':'' }/>, stepNo:0},
            {label:'ข้อมูลบัญชีรับเงิน',icon:<SwapVerticalCircleSharpIcon  fontSize={'large'} color={ (activeStep === 1) ? 'primary':'' }/>, stepNo:1},
            {label:'ช่องทางสมัคร',icon: <SupervisedUserCircleSharpIcon fontSize={'large'} color={ (activeStep === 2) ? 'primary':'' }/>, stepNo:2}
        ];

    const getStepContent = (stepIndex) =>{
        switch (stepIndex) {
            case 0:
                return <RegisterStepComponents previousAction={()=>handleBack()} nextAction={()=>handleNext()}/>;
            case 1:
                return <RegisterStepTwo previousAction={()=>handleBack()} nextAction={()=>handleNext()}/>;
            case 2:
                return <RegisterStepThree previousAction={()=>handleBack()}/>;
            default:
                return 'Unknown stepIndex';
        }
    }

    useEffect(()=>{
        setActiveStep(0)
        //console.log("logo :", logo_register)
    },[])

    return (
        <Grid   container
                direction="column"
                justify="center"
                alignItems="center"
                spacing={2}
        >
            <Grid item xs={10} md={4} xl={4} >
                <a href={`${window.location.origin.replace("customer.", "")}`} target="_blank" rel="noopener noreferrer">
                    <RenderLogoFade imageUrl={logo_register} timer={1500} imageHeight={"100px"}/>
                </a>
            </Grid>
            <h1 style={{display: 'none'}}>หน้าสมัครสมาชิก</h1>
            <Grid item xs={12} md={12} xl={12} style={{width:'100%', backgroundColor:'#000000'}}>
                <Stepper activeStep={activeStep} alternativeLabel style={{width:'100%', backgroundColor:'#000000'}} >
                    {steps.map((step) => (
                        <Step key={step.label}>
                            <StepLabel icon={step.icon} style={{backgroundColor:'#000000'}}>
                                {
                                    (step.stepNo === activeStep)?
                                        (<b style={{color:`${process.env.REACT_APP_PRIMARY_THEME_COLOR}`}}>{step.label}</b>):
                                        (<b style={{color:`#FFFFFF`}}>{step.label}</b>)
                                }
                            </StepLabel>
                        </Step>
                    ))}
                </Stepper>
            <Grid item xs={12} md={12} xl={12} >
                        {getStepContent(activeStep)}
            </Grid>
            </Grid>
        </Grid>
    );
}
